import { Box, Grid } from "@mui/material"
import axios from "axios"
import { useEffect, useState } from "react"
import { SERVER_URI } from "../../utils/config"
import { SingleOrder } from "./SingleOrder"

export const Orders = () => {
	const [orders, setOrders] = useState([])

	useEffect(() => {
		const fetchOrders = async () => {
			try {
				const response = await axios.get(`${SERVER_URI}/get_orders`)
				setOrders(response.data.orders)
			} catch (error) {
				console.error(error)
			}
		}
		fetchOrders()
	}, [])

	return (
		<Box sx={{ justifyContent: "center", alignContent: "center", textAlign: "center" }}>
			<Grid container spacing={2} columns={4}>
				{orders.map((order) => (
					<SingleOrder key={order.orderinfoid} order={order} />
				))}
			</Grid>
		</Box>
	)
}
